function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as h } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as n } from "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as g } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as e } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import "./templates/add-note.js";
import "./templates/address.js";
import "./templates/appointment-confirmed.js";
import "./templates/assets.js";
import "./templates/auto-money.js";
import "./templates/balloons.js";
import "./templates/bank-account.js";
import "./templates/brief-case.js";
import "./templates/calendar-home.js";
import "./templates/change-data.js";
import "./templates/check-with-pencil.js";
import "./templates/co-borrower.js";
import "./templates/co-borrowers-incomplete.js";
import "./templates/co-borrowers.js";
import "./templates/commercial.js";
import "./templates/connectivity.js";
import "./templates/consumer.js";
import "./templates/contact-search.js";
import "./templates/conversation-multiple.js";
import "./templates/credit-card.js";
import "./templates/crop-background.js";
import "./templates/crop-page.js";
import "./templates/declarations-legal.js";
import "./templates/deliver.js";
import "./templates/demographic-info.js";
import "./templates/document-add.js";
import "./templates/document-signature.js";
import "./templates/download-app.js";
import "./templates/empty-box.js";
import "./templates/home-search.js";
import "./templates/house-5.js";
import "./templates/house-6.js";
import "./templates/house-fireworks.js";
import "./templates/house-under-construction.js";
import "./templates/house-with-shield.js";
import "./templates/inquiry.js";
import "./templates/locked.js";
import "./templates/make-an-offer.js";
import "./templates/mortgage.js";
import "./templates/network-error.js";
import "./templates/page-1.js";
import "./templates/page-2.js";
import "./templates/page-3.js";
import "./templates/paper-3.js";
import "./templates/paper-7.js";
import "./templates/person-2.js";
import "./templates/personal-info.js";
import "./templates/portfolio-analytics.js";
import "./templates/price-search.js";
import "./templates/quick-links.js";
import "./templates/register.js";
import "./templates/schedule-home-tour.js";
import "./templates/small-business.js";
import "./templates/social-security.js";
import "./templates/start-conversation.js";
import "./templates/status-no-x.js";
import "./templates/status.js";
import "./templates/success.js";
import "./templates/talkluments.js";
import "./templates/thumbs-down-man.js";
import "./templates/transfer.js";
import "./templates/treasury.js";
import "./templates/unsecured-line-of-credit.js";
import "./templates/upload-cloud.js";
import "./templates/your-bank-placeholder.js";
import "./templates/your-bank.js";
import { illustrations as u } from "../illustration-registry.js";
import v from "../../../packages/web-components/src/components/illustration/gator/illustration.gator.scss.js";
import { unsafeCSS as d } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var y = Object.defineProperty,
  _ = Object.getOwnPropertyDescriptor,
  s = function s(p, i, o, m) {
    for (var r = m > 1 ? void 0 : m ? _(i, o) : i, l = p.length - 1, a; l >= 0; l--) (a = p[l]) && (r = (m ? a(i, o, r) : a(r)) || r);
    return m && r && y(i, o, r), r;
  };
var t = /*#__PURE__*/function (_n) {
  function t() {
    var _this;
    _classCallCheck(this, t);
    _this = _callSuper(this, t, arguments), _this.name = "", _this.label = "", _this.size = void 0, _this.titleText = "", _this.bodyText = "", _this.orientation = "vertical";
    return _this;
  }
  _inherits(t, _n);
  return _createClass(t, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var p, i, o;
      this._svg = (p = this.shadowRoot) == null ? void 0 : p.querySelector("svg"), (i = this._svg) == null || i.classList.add("illustration"), (o = this._svg) == null || o.setAttribute("role", "img");
    }
  }, {
    key: "updated",
    value: function updated(p) {
      var _this2 = this;
      var i, o;
      this.label && ((i = this._svg) == null || i.setAttribute("aria-label", this.label)), (o = this._svg) == null || o.setAttribute("aria-hidden", this.label === "" ? "true" : "false"), p.has("size") && this._svg && (this._svg.classList.forEach(function (m) {
        var r;
        m.startsWith("gator-illustration_") && ((r = _this2._svg) == null || r.classList.remove(m));
      }), this._svg.classList.add("gator-illustration_".concat(this.size))), this.width && this._svg && (this._svg.style.width = this.width), this.height && this._svg && (this._svg.style.height = this.height);
    }
  }, {
    key: "render",
    value: function render() {
      return h(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<div class=\"gator-illustration-container\">\n\t\t\t\t<div class=\"gator-illustration_", " ", "\">\n\t\t\t\t\t", "\n                    ", "\n\t\t\t\t</div>\n\t\t\t\t<slot></slot>\n\t\t\t</div>\n\t\t"])), this.orientation, this.hasText ? "gator-illustration-with-text" : null, u.get(this.name), this.textMarkup);
    }
  }, {
    key: "hasText",
    get: function get() {
      return this.titleText !== "" || this.bodyText !== "";
    }
  }, {
    key: "textMarkup",
    get: function get() {
      return this.hasText ? h(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            <div class=\"gator-illustration-text\">\n                <div class=\"gator-illustration-title\">\n                    ", "\n                </div>\n                <div class=\"gator-illustration-body\">\n                    ", "\n                </div>\n            </div>\n        "])), this.titleText, this.bodyText) : null;
    }
  }]);
}(n);
t.styles = [d(v)];
s([e({
  type: String
})], t.prototype, "name", 2);
s([e()], t.prototype, "label", 2);
s([e({
  type: String
})], t.prototype, "size", 2);
s([e()], t.prototype, "width", 2);
s([e()], t.prototype, "height", 2);
s([e({
  type: String,
  attribute: "title-text"
})], t.prototype, "titleText", 2);
s([e({
  type: String,
  attribute: "body-text"
})], t.prototype, "bodyText", 2);
s([e({
  type: String
})], t.prototype, "orientation", 2);
t = s([g("ngc-illustration")], t);
export { t as NgcIllustration };